<template>
<div v-if="onCallAction" class="fullscreen-container window">
            <!-- Expanded Container-->
            <div @click='callscreen(true)' class="minimize">
                <a href="#/">
                    <img src="@/assets/images/icons/call-screen/icon-minimize.svg" alt="minimize">
                </a>
            </div>
            <div class="expanded-container">
                <div class="container-top">
                    <div class="text-center">
                        <h1 class="call-title">{{ ( getName(callScreenDetails.to) !== '' && getName(callScreenDetails.to).includes('+') ? '' : getName(callScreenDetails.to) ) }}</h1>
                        <h2 class="call-number" v-if="callScreenDetails.to !== ''">{{!callScreenDetails.to.includes('+') ? '+' : ''}} {{  callScreenDetails.to }} </h2>
                        <p class="call-from" v-if="callScreenDetails.from !== ''"> Call from {{ getName( callScreenDetails.from) }}</p>
                        <p class="status" v-if=" callScreenDetails.callStatus === 0">{{  callScreenDetails.callStatusMsg }}</p>
                        <p class="status success" v-if=" callScreenDetails.callStatus === 1">{{  callScreenDetails.callStatusMsg }}</p>
                        <p class="status alert" v-if=" callScreenDetails.callStatus === 2">{{  callScreenDetails.callStatusMsg }}</p>
                        <p class="timer" v-if=" callScreenDetails.callConnected">
                            {{ ( callScreenDetails.callTimer.hour > 0 ?  callScreenDetails.callTimer.hour + " : " : "") + callScreenDetails.callTimer.minute + " : " + callScreenDetails.callTimer.second }}
                        </p>
                    </div>
                </div>
                <div class="container-bottom">
                    <div>
                        <ul class="menu align-center">
                            <li><a class="grow" v-if="callScreenDetails.status.called==0" href="#/"><img src="@/assets/images/icons/call-screen/icon-calls-start.svg" alt="call start"></a></li>
                            <li><a class="grow" v-if="callScreenDetails.status.called==1" @click="stopCall" href="#/"><img src="@/assets/images/icons/call-screen/icon-calls-end.svg" alt="call end"></a></li>
                            <li><a class="grow" v-if="callScreenDetails.status.called==-1" href="#/"><img src="@/assets/images/icons/call-screen/icon-calls.svg" alt="call"></a></li>
                            <!-- <li><a class="grow" v-if="callScreenDetails.status.video==0" href="#/"><img src="@/assets/images/icons/call-screen/icon-video-start.svg" alt="video start"></a></li> -->
                            <!-- <li><a class="grow" v-if="callScreenDetails.status.video==1" href="#/"><img src="@/assets/images/icons/call-screen/icon-video-end.svg" alt="video end"></a></li> -->
                            <!-- <li><a class="grow" v-if="callScreenDetails.status.video==-1" href="#/"><img src="@/assets/images/icons/call-screen/icon-video.svg" alt="video"></a></li> -->
                            <li><a class="grow" v-if="callScreenDetails.status.microphone==1" @click="callMicToggle" href="#/"><img src="@/assets/images/icons/call-screen/icon-micro-on.svg" alt="microphone on"></a></li>
                            <li><a class="grow" v-if="callScreenDetails.status.microphone==0" @click="callMicToggle" href="#/"><img src="@/assets/images/icons/call-screen/icon-micro-off.svg" alt="microphone off"></a></li>
                            <li><a class="grow" v-if="callScreenDetails.status.sound==1" @click="callSoundToggle" href="#/"><img src="@/assets/images/icons/call-screen/icon-sound-on.svg" alt="sound on"></a></li>
                            <li><a class="grow" v-if="callScreenDetails.status.sound==0" @click="callSoundToggle" href="#/"><img src="@/assets/images/icons/call-screen/icon-sound-off.svg" alt="sound off"></a></li>
                            <li><a class="grow" v-if="callScreenDetails.status.recording==0" @click="callRecordToggle" href="#/"><img src="@/assets/images/icons/call-screen/icon-record.svg" alt="recording"></a></li>
                            <li><a class="grow" v-if="callScreenDetails.status.recording==1" @click="callRecordToggle" href="#/"><img src="@/assets/images/icons/call-screen/icon-record-on.svg" alt="recording on"></a></li>
                            <!-- <li><a class="grow" href="#/"><img src="@/assets/images/icons/call-screen/icon-screenshot.svg" alt="screenshot"></a></li> -->
                            <li><a class="grow" @click="dtmfToggle('open')"><img src="@/assets/images/icons/call-screen/icon-dtmf.svg" alt="dtmf"></a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <!-- Minimized Container-->
            <div class="minimized-container">
                <div class="grid-container">
                <div class="grid-x align-middle">
                    <div class="cell small-16 large-5">
                        <p> from <span class="call-title">{{ getName(callScreenDetails.from) }}</span></p>
                        <p> on <span class="call-number">{{ getName(callScreenDetails.to) }}</span></p>
                    </div>
                    <div class="cell small-16 large-5 large-text-center">
                    <p class="status" v-if="callScreenDetails.callStatus === 0"> {{ callScreenDetails.callStatusMsg }} </p>
                    <p class="status success" v-if="callScreenDetails.callStatus === 1">{{ callScreenDetails.callStatusMsg }}</p>
                    <p class="status alert" v-if="callScreenDetails.callStatus === 2">{{ callScreenDetails.callStatusMsg }}</p>
                    <p class="timer" v-if="callScreenDetails.callConnected">
                        {{ (callScreenDetails.callTimer.hour > 0 ? callScreenDetails.callTimer.hour + " : " : "") + callScreenDetails.callTimer.minute + " : " + callScreenDetails.callTimer.second }}
                    </p>
                    </div>
                    <div class="cell small-16 large-6">
                        <ul class="menu align-right actions">
                            <li><a class="grow" @click="dtmfToggle('open')"><img src="@/assets/images/icons/call-screen/icon-dtmf.svg" alt="" width="45"></a></li>
                            <li><a class="grow" v-if="callScreenDetails.status.sound==1" @click="callSoundToggle" href="#/"><img src="@/assets/images/icons/call-screen/icon-sound-on.svg" alt="" width="45"></a></li>
                            <li><a class="grow" v-if="callScreenDetails.status.sound==0" @click="callSoundToggle" href="#/"><img src="@/assets/images/icons/call-screen/icon-sound-off.svg" alt="" width="45"></a></li>
                            <li><a class="grow" v-if="callScreenDetails.status.microphone==1" @click="callMicToggle" href="#/"><img src="@/assets/images/icons/call-screen/icon-micro-on.svg" alt="microphone on" width="45"></a></li>
                            <li><a class="grow" v-if="callScreenDetails.status.microphone==0" @click="callMicToggle" href="#/"><img src="@/assets/images/icons/call-screen/icon-micro-off.svg" alt="microphone off" width="45"></a></li>
                            <li><a class="grow" v-if="callScreenDetails.status.recording==0" @click="callRecordToggle" href="#/"><img src="@/assets/images/icons/call-screen/icon-record.svg" alt="recording" width="45"></a></li>
                            <li><a class="grow" v-if="callScreenDetails.status.recording==1" @click="callRecordToggle" href="#/"><img src="@/assets/images/icons/call-screen/icon-record-on.svg" alt="recording on" width="45"></a></li>
                            <li><a class="grow" @click="stopCall" href="#/"><img src="@/assets/images/icons/call-screen/icon-calls-end.svg" alt="" width="45"></a></li>
                            <li><a class="grow" href="#/" @click='callscreen(false)' ><img src="@/assets/images/icons/call-screen/icon-maximize.svg" alt="expand"></a></li>
                        </ul>
                        <!-- <div @click='callscreen(false)' class="maximize">
                            <a href="#/"><img src="@/assets/images/icons/call-screen/icon-maximize.svg" alt="expand"></a>
                        </div> -->
                    </div>
                </div>
                </div>
            </div>
        </div>

        <!-- MODAL INCOMING CALL-->
        <div id="incomingCall" class="hide" data-close-on-click="false">
            <h1>Incoming Call</h1>
            <hr>
            <div class="text-center incoming">
                <h2>You have an incoming call from </h2>
                <h3 class="large">{{ callScreenDetails.incomingFrom }}</h3>
                <hr class="invisible">
                <ul class="menu align-center">
                    <li>
                        <a @click="updateIncommingCallStatus(true)" class="animate__animated animate__bounce animate__infinite animate__delay-1s" href="#/">
                            <img src="@/assets/images/icons/call-screen/icon-calls-start.svg" alt="answer">
                        </a>
                    </li>
                    <li>
                        <a class="grow" href="#/" @click="updateIncommingCallStatus(false)">
                            <img src="@/assets/images/icons/call-screen/icon-calls-end.svg" data-close=""   alt="reject">
                        </a>
                    </li>
                </ul>
                <hr class="invisible">
            </div>
            <!-- <button class="close-button" data-close="" aria-label="Close modal" type="button">
                <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2">
                    <path d="M10 0a10 10 0 00-7.07 17.071c3.905 3.905 10.236 3.905 14.141 0 3.905-3.905 3.906-10.236 0-14.14A9.94 9.94 0 0010.002 0zm5.934 15.934c-3.27 3.27-8.592 3.27-11.866 0a8.39 8.39 0 1111.866 0z" fill="#161938" fill-rule="nonzero"></path>
                    <path d="M13.91 6.07a.802.802 0 00-1.138 0L9.987 8.856l-2.94-2.942a.803.803 0 10-1.138 1.138L8.85 9.99l-2.941 2.942a.805.805 0 001.138 1.141l2.945-2.944 2.784 2.783a.816.816 0 001.138.004l.004-.004a.802.802 0 000-1.137l-2.784-2.784L13.926 7.2a.813.813 0 00-.016-1.13z" fill="#161938" fill-rule="nonzero"></path>
                </svg>
            </button> -->
        </div>

        <!-- MODAL DTMF-->
        <div id="modalDTMF" class="hide"  data-close-on-click="false">
            <header>
            <input class="transparent" type="text" placeholder="2558524 8484" v-model="dtmfTypeNumber" />
            <hr class="invisible">
            </header>
            <section class="numeric">
            <div class="grid-x grid-margin-x text-center"
                v-for="(dtmfNumpads, index) in dtmfNumpadData" :key="index">
                <div class="cell auto" v-for="(dtmfNumber, numberIndex) in dtmfNumpads" :key="numberIndex">
                    <a @click.prevent="onDtmfBtnClick(dtmfNumber.numKey, dtmfNumber.char)">
                        {{ dtmfNumber.numKey }}<span>{{ dtmfNumber.char }}</span>
                    </a>
                </div>
            </div>
            </section>
            <button class="close-button" @click="dtmfToggle('close')" type="button">
            <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2">
                <path d="M10 0a10 10 0 00-7.07 17.071c3.905 3.905 10.236 3.905 14.141 0 3.905-3.905 3.906-10.236 0-14.14A9.94 9.94 0 0010.002 0zm5.934 15.934c-3.27 3.27-8.592 3.27-11.866 0a8.39 8.39 0 1111.866 0z" fill="#161938" fill-rule="nonzero"></path>
                <path d="M13.91 6.07a.802.802 0 00-1.138 0L9.987 8.856l-2.94-2.942a.803.803 0 10-1.138 1.138L8.85 9.99l-2.941 2.942a.805.805 0 001.138 1.141l2.945-2.944 2.784 2.783a.816.816 0 001.138.004l.004-.004a.802.802 0 000-1.137l-2.784-2.784L13.926 7.2a.813.813 0 00-.016-1.13z" fill="#161938" fill-rule="nonzero"></path>
            </svg>
            </button>
        </div>
</template>
<script>
import { blacktel }from '../../config/pluginInit'
import {
  userDetail,
  capabilityToken
} from "../../config/urlConstants";
import { mapGetters } from "vuex";
export default {
    name:'CallFullScreen',
    data() {
        return{
            // onCallAction: false,
            webSdkStatus: {
                plivoService: false,
                twilioService: false,
                activeNumberStatus: false,
            },
            userRequest: {
                mid: localStorage.getItem("mid"),
                secureid: localStorage.getItem("secureid"),
            },
            plivoLoginRequest: {
                username: "",
                password: "",
            },
            callScreenDetails: {
                incomingFrom: '',
                uuid: '',
                to: '',
                from: '',
                callStatus: 0,
                callConnected: true,
                callStatusMsg: 'Calling... ',
                callTimer: {
                    hour: '00',
                    minute: '00',
                    second: '00'
                },
                status: {
                    called: 1,
                    video: -1,
                    microphone: 1,
                    sound: 1,
                    recording: 0
                }
            },
            credit: 0,
            minimizeScreen : false,
            isDtmf: false,
            dtmfNumpadData: [
                [
                    { numKey: 1, char: "" },
                    { numKey: 2, char: "ABC" },
                    { numKey: 3, char: "DEF" }
                ], [
                    { numKey: 4, char: "GHI" },
                    { numKey: 5, char: "JKL" },
                    { numKey: 6, char: "MNO" }
                ],[
                    { numKey: 7, char: "PQRS" },
                    { numKey: 8, char: "TUV" },
                    { numKey: 9, char: "WXYZ" }
                ],[
                    { numKey: "*", char: "" },
                    { numKey: 0, char: "" },
                    { numKey: "#", char: "" }
                ]
            ],
            dtmfTypeNumber: "",
            twilioConnection: {},
            activeCallService: '',
            twillioCallConnection: {},
            incommingModel: '',
            incommingModel1: '',
            dmftModel: '',
            isIncomingModelVisible: false,
            errorLog: [],
            dynamicModel: '',
            twilioConnect: {}
        }
    },
    mounted () {
        $(document).foundation();
        blacktel.foundationInit()
        this.getUserDetail()
        this.twilioInit()
        this.plivoInit();
        setTimeout(() => {
            $(document).ready(function(){
                $(document).foundation();
            });
        }, 2000);
    },
    unmounted(){
        blacktel.foundationInit()
        // this.incommingModel.destroy();
    },
    methods: {
        updateIncommingCallStatus(status) {
            if(this.activeCallService == 'plivo') {
                if (status) {
                    // Plivo incomming call accept
                    window.plivoBrowserSdk.client.answer(this.callScreenDetails.uuid);
                } else {
                    // Plivo incomming call reject
                    window.plivoBrowserSdk.client.reject(this.callScreenDetails.uuid);
                    this.callingLayoutDisplay(false);
                    // location.reload();
                }
            } else {
                if(status) {
                    // Twilio incomming call accept
                    this.twillioCallConnection.accept();
                    // console.log('%c Twilio Call accept', 'background: #000; color: #00E676');
                    this.callScreenDetails.callStatusMsg = "Voice call in progress";
                    // this.callDuration();
                    this.callStatusUpdate(true);
                    this.callingLayoutDisplay(true);
                } else {
                    // Twilio incomming call reject
                    this.twillioCallConnection.reject();
                    this.callingLayoutDisplay(false);
                }
            }
            this.modelActions('close');
        },
        stopCall() {
            if(this.activeCallService == 'plivo') {
                 // Stop ongoing call
                if (window.plivoBrowserSdk.client.callSession) {
                    window.plivoBrowserSdk.client.hangup();
                } else {
                    window.plivoBrowserSdk.client.setRingToneBack(false);
                    window.Twilio.Devices.disconnectAll();
                }
                this.callingLayoutDisplay(false);
                this.callStatusUpdate(false);
                this.getUserDetail();
                this.callScreenMin = false;
                this.dtmfTypeNumber = "";
            } else {
                this.twillioCallConnection.disconnect();
                this.callingLayoutDisplay(false);
            }
        },
        callMicToggle() {
            if(this.activeCallService == 'plivo') {
                if (this.callScreenDetails.status.microphone == 1) {
                    this.callScreenDetails.status.microphone = 0
                    window.plivoBrowserSdk.client.mute();
                } else {
                    this.callScreenDetails.status.microphone = 1
                    window.plivoBrowserSdk.client.unmute();
                }
            } else {
                if (this.callScreenDetails.status.microphone == 1) {
                    this.callScreenDetails.status.microphone = 0
                    this.twillioCallConnection.mute(true);
                } else {
                    this.callScreenDetails.status.microphone = 1
                    this.twillioCallConnection.mute(false);
                }
            }
        },
        callSoundToggle() {
            if(this.activeCallService == 'plivo') {
                if (this.callScreenDetails.status.sound == 1) {
                    this.callScreenDetails.status.sound = 0
                    window.plivoBrowserSdk.client.mute();
                } else {
                    this.callScreenDetails.status.sound = 1
                    window.plivoBrowserSdk.client.unmute();
                }
            }  else {
                 if (this.callScreenDetails.status.sound == 1) {
                    this.callScreenDetails.status.sound = 0
                    this.twillioCallConnection.mute(true);
                } else {
                    this.callScreenDetails.status.sound = 1
                    this.twillioCallConnection.mute(false);
                }
            }
        },
        callRecordToggle() {
            if (this.callScreenDetails.status.recording == 1) {
                this.callScreenDetails.status.recording = 0
            } else {
                this.callScreenDetails.status.recording = 1
            }
        },
        getName (number) {
            if(number == undefined || number == '') return '';
            // get name from address book contact
            let result = blacktel.searchAddressBookName(number)
            let result1 = blacktel.searchvirtualNumbersName(number)
            if(result != number){
                return result
            }else if (result1 != number){
                return result1
            }else {
                if(number.includes("+")) {
                    return number
                } else {
                    return '+' + number
                }
            }
        },
        callscreen(value){
            if(this.minimizeScreen===value){
                document.body.classList.add('expanded-call');
                document.body.classList.remove('minimized-call');
            }else{
                document.body.classList.add('minimized-call');
                document.body.classList.remove('expanded-call');
            }
        },
        dtmfToggle(type = '') {
            // this.isDtmf = !this.isDtmf;
            // this.incommingModel.open();
            // var popup = new Foundation.Reveal($('#modalDTMF'));
            if(type == 'open') {
                // popup.open();
                this.dtmfModelActions('open');
            } else {
                // popup.close();
                this.dtmfModelActions('close');
                // $('.reveal-overlay').css('display', 'none');
            }
        },
        onDtmfBtnClick(digit) {
            if (this.dtmfTypeNumber.length > 12) this.dtmfTypeNumber = "";
            if (
                this.activeCallService === "twilio" &&
                this.twilioConnection !== "" &&
                this.twilioConnection !== null
            )
            {
                this.twilioConnection.sendDigits(digit.toString());
            } else {
                window.plivoBrowserSdk.client.sendDtmf(digit);
            }
            this.dtmfTypeNumber = this.dtmfTypeNumber.concat(digit);
        },
        getUserDetail() {
            // get login user detail
            let _this = this;
            this.$store.dispatch("btPostApi", {
                url: userDetail,
                data: this.userRequest,
            })
            .then((response) => {
                if (response.data[0].status === "success") {
                    let pass = localStorage.getItem("secureid");
                    let credit = response.data[1].messages.credit;
                    if (response.data[1].messages.endpoints.length > 0) {
                        let plivioUsername = response.data[1].messages.endpoints[0].username;
                        _this.plivoLoginRequest.username = plivioUsername;
                        _this.plivoLoginRequest.password = pass;
                    }
                    _this.credit = credit;
                }
            });
        },
        plivoLogin(username, password) {
            // plivo service login
            //  let _this = this ;
             try {
                setTimeout(() => {
                    window.plivoBrowserSdk.client.login(username, password);
                }, 2000);
             } catch (err) {
                setTimeout(() => {
                    blacktel.showSnackbar('error', 'Network error : please check your network and reload the page!')
                }, 1000);
            }
        },
        plivoInit() {
            var networkError = false ;
            // following function is implemented for initialization of plivo webSDK
            // and plivo event listening
            try {
                window.plivoBrowserSdk = new window.Plivo({
                    debug: "OFF",
                    permOnClick: true,
                    enableIPV6: false,
                    audioConstraints: {
                    optional: [
                        { googAutoGainControl: false },
                        { googEchoCancellation: false },
                    ],
                    },
                    dscp: true,
                    enableTracking: true,
                });
            } catch (err) {
                networkError = true ;
                setTimeout(() => {
                    blacktel.showSnackbar('error', 'Network error : please check your network and reload the page!')
                }, 1000);
            }

            // is not a network error
            if(!networkError) {
                let plivioSdk = window.plivoBrowserSdk;
                plivioSdk.client.on("onWebrtcNotSupported", () => {
                    blacktel.showSnackbar('error', 'Media not supported.');
                });
                plivioSdk.client.on("onMediaConnected", () => {
                    // console.log('%c Plivo : onMediaConnected ' , 'background: #000; color: #00E676');
                });
                plivioSdk.client.on("onLogin", () => {
                    // console.log('%c Plivo : onLogin ' , 'background: #000; color: #00E676');
                    this.webSdkStatus.plivoService = true;
                });
                plivioSdk.client.on("onLoginFailed", () => {
                    // console.log('%c Plivo : onLoginFailed ' , 'background: #000; color: #00E676');
                    this.webSdkStatus.plivoService = false;
                });
                plivioSdk.client.on("onCalling", () => {
                    // console.log('%c Plivo : onCalling ' , 'background: #000; color: #00E676');
                    this.activeCallService = 'plivo' ;
                    let _this = this;
                    // this.onCallAction = true;
                    this.$store.dispatch("callStatusUpdate", true);
                    setTimeout(function () {
                        let callData = _this.$store.state.activeCallData;
                        if (callData.direction === "out") {
                            _this.callScreenDetails.to = callData.to;
                            _this.callScreenDetails.from = callData.from;
                        } else {
                            _this.callScreenDetails.to = callData.from;
                            _this.callScreenDetails.from = callData.to;
                        }
                    }, 1000);
                });
                plivioSdk.client.on("onIncomingCall", (e) => {
                    // console.clear();
                   // console.log('%c Plivo : onIncomingCall ' , 'background: #000; color: #00E676');
                    this.activeCallService = 'plivo' ;
                    this.modelActions('open');
                    let callFrom = e;
                    if (callFrom !== "" && callFrom !== undefined) {
                        let indexOfat = callFrom.indexOf("@");
                        callFrom = callFrom.slice(0, indexOfat);
                        this.callScreenDetails.from = callFrom;
                        // this.onCallAction = true;
                        this.$store.dispatch("callStatusUpdate", true);
                        this.callScreenDetails.uuid = e;
                        this.callScreenDetails.callStatusMsg = "Voice call in progress";
                    }
                });
                plivioSdk.client.on("onConnectionChange", (e) => {
                    // console.log('%c Plivo : onConnectionChange ' , 'background: #000; color: #00E676');
                    if (e.state !== "connected") {
                        blacktel.showSnackbar('error', ' Network: Disconnected! ')
                        setTimeout(() => {
                            blacktel.showSnackbar('error', ' Network: Please reload page for reconnect! ')
                        }, 1000);
                    }
                });
                plivioSdk.client.on("onIncomingCallCanceled", () => {
                    // console.log('%c Plivo : onIncomingCallCanceled ' , 'background: #000; color: #00E676');
                    this.activeCallService = 'plivo' ;
                    this.callStatusUpdate(false);
                    this.callingLayoutDisplay(false);
                    this.modelActions('close');
                    setTimeout(function () {
                        Foundation.reInit('reveal');
                    }, 2000);
                });
                plivioSdk.client.on("onCallAnswered", (e) => {
                    // console.log('%c Plivo : onCallAnswered ' , 'background: #000; color: #00E676');
                    if(e.direction === "incoming") {
                        this.callScreenDetails.from = e.src ;
                        this.callScreenDetails.to = e.extraHeaders['X-Ph-To'];
                    } else {
                        this.callScreenDetails.to = e.dest
                    }
                    this.activeCallService = 'plivo' ;
                    this.callingLayoutDisplay(true);
                    this.callScreenDetails.callStatusMsg = "Voice call in progress";
                    this.callDuration();
                    this.callStatusUpdate(true);
                });
                plivioSdk.client.on("onCallTerminated", () => {
                    this.getCredit();
                    // remove header minimize call div when call ended
                    document.body.classList.remove("minimized-call");
                    this.callScreenDetails.to = "";
                    this.dtmfTypeNumber = "";
                    this.callScreenDetails.callConnected = false;
                    this.minimizeScreen = false;
                    // this.onCallAction = false;
                    this.$store.dispatch("callStatusUpdate", false);
                    this.callingLayoutDisplay(false);
                    this.callStatusUpdate(false);
                    this.activeCallService = 'plivo' ;
                });
                plivioSdk.client.on("onCallFailed", (e) => {
                    this.getCredit();
                    this.activeCallService = 'plivo' ;
                    this.callScreenDetails.to = "";
                    this.dtmfTypeNumber = "";
                    this.callScreenMin = false;
                    this.callStatusUpdate(false);
                    let _this = this;
                    if (e === "Busy") {
                        this.callScreenDetails.callStatusMsg = "Line Busy...";
                    } else if (e === "Unavailable") {
                        this.callScreenDetails.callStatusMsg = "Call Can't connect due to Nework issue...";
                    } else {
                        this.callScreenDetails.callStatusMsg = "Call Can't connect...";
                    }
                    this.callScreenDetails.callConnected = false;
                    setTimeout(function () {
                        _this.callingLayoutDisplay(false);
                        // location.reload();
                    }, 2000);
                });
                plivioSdk.client.audio
                    .availableDevices()
                    .then(function (e) {
                        e.forEach(function (dev) {
                            if (dev.label && dev.kind === "audioinput") {
                                plivioSdk.client.audio.microphoneDevices.set(dev.deviceId);
                            }
                            if (dev.label && dev.kind === "audiooutput") {
                              // Audio Out Block
                            }
                        });
                    })
                    .catch(function (error) {
                        blacktel.showSnackbar("error", error);
                    });
                plivioSdk.client.setRingTone(true);
                plivioSdk.client.setRingToneBack(true);
            }
        },
        twilioInit() {

            this.getCapabilityToken((token) => {
              if(localStorage.getItem("mid") !== '' && localStorage.getItem("mid") !== null && localStorage.getItem("secureid") !== '' && localStorage.getItem("secureid") !== null) {
                  if(window.Twilio !== undefined && window.Twilio.Device !== undefined) {
                      window.Twilio.Devices = new window.Twilio.Device(token, {
                          enableRingingState : true ,
                              debug: false
                          });
                      this.loadTwilio();
                      window.Twilio.Devices.register()
                  }
              }
            });
            // following function is implemented for initialization of twilio webSDK and twilio event listening

        },
        loadTwilio() {
            if(window.Twilio !== undefined) {
              window.Twilio.Devices.on("registered", this.register);
              window.Twilio.Devices.on("incoming", this.incoming);
              window.Twilio.Devices.on('error', this.error);
              window.Twilio.Devices.on('tokenWillExpire', () => {
                this.getCapabilityToken((response) => {
                  window.Twilio.Devices.updateToken(response.data.token)
                })
              })
              window.Twilio.Devices.on('unregistered', this.disconnect)
              window.Twilio.Devices.on("disconnect", this.disconnect);
              window.Twilio.Devices.connected = this.connected;
            }
        },
        // Twilio Functions Start
        register(){
          // console.log('%c Twilio: Registered', 'background: #000; color: #00E676');
          this.webSdkStatus.twilioService = true;
        },
        connected(call){
          // console.log('%c Twilio: Connected ' , 'background: #000; color: #00E676');
          this.activeCallService = 'twilio' ;
          this.twilioConnection = call ;
          this.twillioCallConnection = call ;
          // this.onCallAction = true
          // console.log(call)
          this.$store.dispatch("callStatusUpdate", true);
          if(call.direction == 'OUTGOING') {
              call.customParameters.forEach((index, item) => {
                  if(item == 'To') {
                      this.callScreenDetails.to = index;
                  }
              });
              // this.callDuration();
              this.callScreenDetails.from = '' ;
          }
          // this.callDuration();
          this.callStatusUpdate(true);
          call.on('error', this.error)
          call.on('disconnect', this.disconnect)
          call.on("cancel", this.cancel);
          call.on("accept", this.accept);
          call.on("reject", this.reject);
        //   call.on('sample', sample => {
        //       console.log(sample)
        //   });
          call.on('warning', function(warningName) {
            // console.group('Twilio:- Call Warning')
            // console.log(warningName)
            if (warningName === 'low-mos') {
              // console.log('We have detected poor call quality conditions. You may experience degraded call quality.')
              // console.log(warningData);
            }
            // console.groupEnd()
          })
        },
        incoming(connection){
            // console.log('%c Twilio: Incomming call', 'background: #000; color: #00E676');
            this.activeCallService = 'twilio' ;
            this.twillioCallConnection = connection ;
            // More complex structure
            this.modelActions('open');
            this.callScreenDetails.incomingFrom = connection.parameters.From
            this.callScreenDetails.to = connection.parameters.From;
            connection.customParameters.forEach((index, item) => {
                if(item == 'vn_number') {
                    this.callScreenDetails.from = '+'+index
                }
            })

            this.connected(connection)
            this.$store.dispatch("callStatusUpdate", true);
        },
        cancel(connection){
          // console.log('%c Twilio : Cancel', 'background: #000; color: #00E676');
          this.activeCallService = 'twilio' ;
          this.twillioCallConnection = connection ;
          this.modelActions('close');
          this.callingLayoutDisplay(false);
          this.getCredit();
        },
        accept(connection){
          // console.log('%c Twilio: Accept ', connection , 'background: #000; color: #00E676');
          this.callScreenDetails.callConnected = true;
          this.callScreenDetails.callStatusMsg = "Voice call in progress";
          this.callDuration();
          this.twillioCallConnection = connection ;
          this.activeCallService = 'twilio' ;
        },
        reject(){
          // console.log('%c Twilio: reject', 'background: #000; color: #00E676');
          this.activeCallService = 'twilio' ;
          this.getCredit();
        },
        ringing(connection){
          // console.log('%c Twilio: ringing ', 'background: #000; color: #00E676');
          this.twillioCallConnection = connection ;
          this.activeCallService = 'twilio' ;
        },
        disconnect(){
          this.callingLayoutDisplay(false);
          // console.log('%c Twilio: disconnect ', 'background: #000; color: #00E676');
          this.callScreenDetails.to = "";
          this.dtmfTypeNumber = "";
          this.minimizeScreen = false;
          this.callScreenDetails.callConnected = false;
          this.webSdkStatus.twilioService = false;
          // this.onCallAction = false ;
          this.$store.dispatch("callStatusUpdate", false);
          document.body.classList.remove("activity-page");
          document.body.classList.remove("iq-top-call-display");
          document.body.classList.remove("iq-call-fullscreen");
          this.getCredit();
          // this.getCapabilityToken((response) => {
          //   window.Twilio.Devices.updateToken(response.data.token)
          // })
        },
        error(error){
          this.getCredit();
          if(error.code == 31009) {
              blacktel.showSnackbar('error', 'Network error : please check your network and reload the page!')
          }else if(error.message != '') {
              blacktel.showSnackbar('error', 'Error : '+ error.message);
          } else {
              blacktel.showSnackbar('error', 'Network error : please check your network and reload the page!')
          }
        },
        // Twilio Functions End
        getCapabilityToken(callback) {
            // following function is implemented for get twilio capability token
            // and setup twilio device.
            // console.log('%c Twilio: Token ', 'background: #000; color: #00E676');
            this.$store
                .dispatch("btPostApi", {
                    url: capabilityToken,
                    data: this.userRequest,
                })
                .then((response) => {
                  localStorage.setItem("capability_token", response.data.token);
                  callback(response.data.token)
                });
        },
        callingLayoutDisplay(flag) {
            if (flag) {
                document.body.classList.add("activity-page");
                document.body.classList.add("iq-top-call-display");
                document.body.classList.add("iq-call-fullscreen");
                this.callScreenDetails.callConnected = true;
                // this.onCallAction = true;
                this.$store.dispatch("callStatusUpdate", true);
                this.callScreenDetails.callStatusMsg = "Voice call in progress";
            } else {
                this.callScreenDetails.callConnected = false;
                document.body.classList.remove("activity-page");
                document.body.classList.remove("iq-top-call-display");
                document.body.classList.remove("iq-call-fullscreen");
                this.callScreenDetails.callStatusMsg = "Calling...";
                // this.onCallAction = false;
                this.$store.dispatch("callStatusUpdate", false);
                 document.body.classList.remove("minimized-call");
            }
        },
        callStatusUpdate(status) {
            this.$store.dispatch("callStatusUpdate", status);
        },
        callDuration() {
            // Ongoing call timer
            let second = 0;
            let minute = 0;
            let hour = 0;
            let _this = this;
            let callInterval = setInterval(function () {
                if (_this.callScreenDetails.callConnected) {
                    second = parseInt(second) + 1;
                    if (second === 60) {
                        minute = parseInt(minute) + 1;
                        second = 0;
                    } else if (minute === 60) {
                        hour = parseInt(hour) + 1;
                        minute = 0;
                    }
                } else {
                    clearInterval(callInterval);
                }
                _this.callScreenDetails.callTimer.minute = (minute < 10 ? "0" : "") + minute;
                _this.callScreenDetails.callTimer.second = (second < 10 ? "0" : "") + second;
                _this.callScreenDetails.callTimer.hour = (hour < 10 ? "0" : "") + hour;
            }, 1000);
        },
        dtmfModelActions(action) {
            let incomingModelInstance = $('#modalDTMF');
            this.dmftModel = new Foundation.Reveal($('#modalDTMF'));
            if(action == 'open') {
                incomingModelInstance.addClass('reveal');
                incomingModelInstance.removeClass('hide');
                incomingModelInstance.attr('data-reveal', '');
                this.dmftModel.open();
            } else {
                this.dmftModel.close();
                $('#modalDTMF').foundation('_destroy');
                $('.reveal-overlay').css('display', 'none');
                incomingModelInstance.addClass('hide');
                incomingModelInstance.removeClass('reveal');
                incomingModelInstance.removeAttr('data-reveal');
                incomingModelInstance.removeAttr('aria-controls');
                incomingModelInstance.removeAttr('data-yeti-box');
            }
        },
        modelActions(action) {
            let incomingModelInstance = $('#incomingCall');
            incomingModelInstance.addClass('reveal');
            incomingModelInstance.removeClass('hide');
            incomingModelInstance.attr('data-reveal', '');
            this.isIncomingModelVisible = true;
            this.incommingModel = new Foundation.Reveal($('#incomingCall'));
            if(action == 'open') {
                this.incommingModel.open();
            } else {
                this.incommingModel.close();
                $('.reveal-overlay').css('display', 'none');
                incomingModelInstance.foundation('close');
                incomingModelInstance.addClass('hide');
                incomingModelInstance.removeClass('reveal');
                incomingModelInstance.removeAttr('data-reveal');
            }
        },
        modalDTMFAction(action) {
            if(action == 'close') {
                $('.reveal-overlay').css('display', 'none');
            }
        }
    },
    computed: {
        ...mapGetters({
            virtualNumbers: "virtualNumbers",
        }),
        ...mapGetters({
            accountCredit: "accountCredit",
        }),
        ...mapGetters({
            onCallAction: "callStatus",
        }),
        webPhoneStatus() {
            if(this.webSdkStatus.plivoService === true &&
                this.webSdkStatus.twilioService === true)
                return true;
            else return false;
        }
    },
    watch: {
        // virtualNumbers: function (vNumbers) {
        //     if(vNumbers == [] || vNumbers == undefined) {
        //         return false ;
        //     }
        //     let activeVNumber = [];
        //     activeVNumber = vNumbers.filter(function (item) {
        //         return item.active === "1";
        //     });
        //     if (activeVNumber.length === 0) {
        //         this.webSdkStatus.activeNumberStatus = true;
        //     } else {
        //         this.webSdkStatus.activeNumberStatus = false;
        //     }
        // },
        accountCredit: function (credit) {
            this.credit = credit;
        },
    },
}
</script>
